import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ResponsiveImage from './ResponsiveImage';

export default function ShowcaseSection() {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 700, once: true });
  }, []);

  useEffect(() => {
    if (!sectionRef.current) return;
    const obs = new IntersectionObserver(
      ([e]) => setActive(e.isIntersecting),
      { threshold: 0.25 }
    );
    obs.observe(sectionRef.current);
    return () => {
      obs.disconnect();
    };
  }, []);

  const headingLines = t('showcase.heading').split('\\n');

  return (
    <section
      ref={sectionRef}
      className={`transition-colors duration-700 ${
        active ? 'bg-[#B1F0F0]' : 'bg-[#E0F7F7]'
      }`}
    >
      <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-y-16 lg:gap-x-24 py-24 lg:py-32">
        <div className="max-w-md text-left space-y-6" data-aos="fade-right">
          <h3 className="text-4xl md:text-6xl font-bold text-brand leading-tight">
            {headingLines.map((line, i) => (
              <React.Fragment key={i}>
                {line}
                {i < headingLines.length - 1 && <br />}
              </React.Fragment>
            ))}
          </h3>
          <p className="text-lg text-gray-700">{t('showcase.desc')}</p>
        </div>
        <div className="flex justify-center gap-10" data-aos="fade-left">
          <ResponsiveImage
            srcBase="/images/mockup-1"
            alt={t('showcase.alt1')}
            className="w-40 md:w-48 lg:w-56 xl:w-64 drop-shadow-2xl rounded-[2rem] rotate-[2deg]"
            loading="lazy"
          />
          <ResponsiveImage
            srcBase="/images/mockup-2"
            alt={t('showcase.alt2')}
            className="w-40 md:w-48 lg:w-56 xl:w-64 drop-shadow-2xl rounded-[2rem] -translate-y-4 -rotate-[3deg]"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}
